import React from "react";
import UniversalForm from "../../../components/UniversalForm/UniversalForm";
import {
  useCompanyFormConfig,
  CompanyFormProps,
} from "../../../components/UniversalForm/entityForms";

const CompanyForm: React.FC<CompanyFormProps> = (props) => {
  const config = useCompanyFormConfig(props);
  return (
    <div className="offcanvas-body">
      <UniversalForm key={config.resetKey} config={config} />
    </div>
  );
};

export default CompanyForm;
